import React, { useEffect, useState } from "react";
// import axios from "axios";
import axios from "../../context/axios";
import { Link, useLocation } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";
import { initTE, Ripple } from "tw-elements";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import Cookies from "js-cookie";
import { FaStar, FaRegStar, FaStarHalfAlt } from "react-icons/fa";
import Confetti from "react-confetti";
import { useWindowSize } from "react-use";
const Beach = () => {
  const location = useLocation();
  const title = location.pathname.split("/").pop();
  // const urlParams = new URLSearchParams(location.search);
  // const initialCategoryId =
  //   location.state?.payload?.categoryId || urlParams.get("category") || null;
  const passedRegionId = location.state?.regionId || null;

  const urlParams = new URLSearchParams(location.search);
  const initialCategoryId =
    location.state?.payload?.categoryId || urlParams.get("category") || null;
  const regionFromUrl = urlParams.get("region") || null;

  const initialRegion = passedRegionId || regionFromUrl || null;


  const [showConfetti, setShowConfetti] = useState(false);
const { width, height } = useWindowSize();
  // const searchQuery = urlParams.get("search") || "";
  const [searchQuery, setSearchQuery] = useState(urlParams.get("search") || "");

  console.log("Initial categoryId:", initialCategoryId);
  const [regionList, setRegionList] = useState([]);
  const [ratings, setRatings] = useState({});
  const fetchTourRating = async (tourId) => {
    try {
      const res = await axios.get(`/reviews/tour-rating/${tourId}`);
      const data = res.data;
      setRatings((prev) => ({
        ...prev,
        [tourId]: data,
      }));
    } catch (err) {
      console.error(`Error fetching rating for tour ${tourId}:`, err.message);
    }
  };
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categories, setCategories] = useState([]);

  const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(initialCategoryId);


  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const categoryFromUrl = urlParams.get("category") || null;
    setSelectedCategory(categoryFromUrl);
  }, [location.search]);

  
  const [showRegionDropdown, setShowRegionDropdown] = useState(false);
  // const [selectedRegion, setSelectedRegion] = useState(null);
  const initialRegionId = location.state?.regionId || null;

  const [selectedRegion, setSelectedRegion] = useState(initialRegionId);

  const [priceRange, setPriceRange] = useState([0, 9999999]); // default price range example
  const [duration, setDuration] = useState(null);
  const [sortBy, setSortBy] = useState(null);
  useEffect(() => {
    if (location.state?.regionId) {
      setSelectedRegion(location.state.regionId);
    }
  }, [location.state?.regionId]);
  const [currentPage, setCurrentPage] = useState(1);
  const limit = 15; // items per page
  const [totalPages, setTotalPages] = useState(1);
  const [wishlist, setWishlist] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchWishlist = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const res = await axios.get(`/wishlist/${user._id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        // Filter out null tourId entries
        const validWishlist = res.data
          .filter((item) => item.tourId)
          .map((item) => item.tourId._id);

        setWishlist(validWishlist);
      } catch (err) {
        console.log(err.message);
      }
    };
    fetchWishlist();
  }, []);

  useEffect(() => {
    const fetchRegions = async () => {
      try {
        const res = await axios.get("/getcoutryregion");
        setRegionList(res.data); // Add this state below
      } catch (error) {
        console.error("Failed to fetch regions:", error);
      }
    };

    fetchRegions();
  }, []);

  const handleWishlistToggle = async (tourId) => {
    const token = localStorage.getItem("token");
    if (!token) return navigate("/login");

    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user?._id;
    const isWishlisted = wishlist.includes(tourId);

    try {
      if (isWishlisted) {
        await axios.delete(`/wishlist/remove`, {
          headers: { Authorization: `Bearer ${token}` },
          data: { userId, tourId },
        });
        setWishlist((prev) => prev.filter((id) => id !== tourId));
        toast.success("Removed from wishlist");
      } else {
        await axios.post(
          `/wishlist/add`,
          { tourId, userId },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setWishlist((prev) => [...prev, tourId]);
        setShowConfetti(true); 
        setTimeout(() => setShowConfetti(false), 6000);
        toast.success("Added to wishlist");
      }
    } catch (err) {
      toast.error("Error updating wishlist");
      console.error("Wishlist error:", err.message);
    }
  };

  const handlePackageClick = async (tourId) => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (user && user._id) {
      // Logged-in user: send to backend
      try {
        await axios.post("/recent-views", {
          userId: user._id,
          packageId: tourId,
        });
      } catch (error) {
        console.error("Failed to save recent view:", error);
      }
    } else {
      // Non logged-in user: store in cookie
      let recentViews = Cookies.get("recentViews");
      recentViews = recentViews ? JSON.parse(recentViews) : [];

      recentViews = [
        tourId,
        ...recentViews.filter((id) => id !== tourId),
      ].slice(0, 7);

      Cookies.set("recentViews", JSON.stringify(recentViews), { expires: 10 });
    }
  };
  // Fetch categories once on mount
  useEffect(() => {
    initTE({ Ripple });

    const fetchCategories = async () => {
      try {
        const catRes = await axios.get("/categories");
        setCategories(catRes.data);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
      }
    };

    fetchCategories();
  }, []);

  // Fetch tours whenever filters change
  useEffect(() => {
    const getTours = async () => {
      setLoading(true);
      try {
        const params = {
          ...(selectedCategory && { category: selectedCategory }),
          ...(selectedRegion && { region: selectedRegion }),
          ...(duration?.min && { minDuration: duration.min }),
          ...(duration?.max && { maxDuration: duration.max }),
          ...(sortBy && { sortBy }),
          ...(priceRange?.[0] !== undefined && { minPrice: priceRange[0] }),
          ...(priceRange?.[1] !== undefined && { maxPrice: priceRange[1] }),
          ...(searchQuery && { search: searchQuery }),
          limit,
          page: currentPage,
        };
        const response = await axios.get("/tours", {
          params,
          headers: {
            "Cache-Control": "no-cache",
          },
        });
        console.log("response", response);
        // setTimeout(() => {
        setTours(response.data.tours);

        setTotalPages(
          response.data.totalPages ||
            Math.ceil(response.data.totalCount / limit)
        );

        setLoading(false);
        // }, 5000);
      } catch (err) {
        console.error("Error fetching tours:", err.message);
        setTours([]); // optionally clear tours on error
      } finally {
        setLoading(false);
      }
    };

    getTours();
  }, [
    title,
    selectedCategory,
    selectedRegion,
    priceRange,
    duration,
    sortBy,
    searchQuery,
    currentPage,
  ]);
  useEffect(() => {
    setCurrentPage(1);
  }, [
    selectedCategory,
    selectedRegion,
    priceRange,
    duration,
    sortBy,
    searchQuery,
    title,
  ]);

  // Handlers for dropdown selections
  const handleCategorySelect = (categoryId) => {
    setSelectedCategory(categoryId);
    setShowCategoryDropdown(false);

    const newUrl = new URL(window.location.href);
    if (categoryId) {
      newUrl.searchParams.set("category", categoryId);
    } else {
      newUrl.searchParams.delete("category");
    }
    window.history.replaceState(null, "", newUrl.toString());
  };

  const handleRegionSelect = (region) => {
    setSelectedRegion(region);
    setShowRegionDropdown(false);
  };


  const renderPagination = () => {
    const delta = 2; // how many pages to show around currentPage
    const range = [];
    const rangeWithDots = [];
    let l;
  
    for (let i = 1; i <= totalPages; i++) {
      if (
        i === 1 ||
        i === totalPages ||
        (i >= currentPage - delta && i <= currentPage + delta)
      ) {
        range.push(i);
      }
    }
  
    for (let i of range) {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l > 2) {
          rangeWithDots.push("...");
        }
      }
      rangeWithDots.push(i);
      l = i;
    }
  
    return rangeWithDots.map((pageNum, index) =>
      pageNum === "..." ? (
        <span key={`ellipsis-${index}`} className="px-3 py-1 text-gray-500">
          ...
        </span>
      ) : (
        <button
          key={pageNum}
          onClick={() => setCurrentPage(pageNum)}
          className={`px-3 py-1 rounded ${
            pageNum === currentPage
              ? "bg-blue-700 text-white font-bold"
              : "bg-gray-200 hover:bg-gray-300"
          }`}
        >
          {pageNum}
        </button>
      )
    );
  };

  // if (loading) return <div>Loading...</div>;
  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-[#f8f9fc]">
       {showConfetti && (
      <Confetti
        width={width}
        height={height}
        recycle={false}
        numberOfPieces={500}
        gravity={0.2}
        style={{ position: 'fixed' }} // Make it cover entire screen
      />
    )}
      {/* Sidebar */}
      <aside className="md:w-[25vw] w-full bg-white p-6 shadow-md">
        <h2 className="text-3xl font-bold text-blue-800 mb-6">
          Filter Your Tour
        </h2>
        <Toaster position="top-right" />
        <div className="space-y-8 text-sm text-gray-800">
          {/* Category Dropdown */}
          <div className="relative">
            <button
              onClick={() => setShowCategoryDropdown(!showCategoryDropdown)}
              className="w-full flex justify-between items-center bg-gray-100 px-4 py-2 rounded-md hover:bg-gray-200 transition"
            >
              <span>
                {selectedCategory
                  ? categories.find((c) => c._id === selectedCategory)?.name
                  : "Category"}
              </span>
              <FaChevronDown />
            </button>

            {showCategoryDropdown && (
              <div className="absolute left-0 right-0 mt-2 bg-white border rounded-md shadow-lg z-50 max-h-60 overflow-y-auto">
                {/* None Option */}
                <div
                  onClick={() => handleCategorySelect(null)}
                  className="px-4 py-2 hover:bg-blue-100 cursor-pointer"
                >
                  None
                </div>

                {categories.map((cat) => (
                  <div
                    key={cat._id}
                    onClick={() => handleCategorySelect(cat._id)}
                    className="px-4 py-2 hover:bg-blue-100 cursor-pointer"
                  >
                    {cat.name}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Region Dropdown */}
          {/* <div className="relative">
            <button
              onClick={() => setShowRegionDropdown(!showRegionDropdown)}
              className="w-full flex justify-between items-center bg-gray-100 px-4 py-2 rounded-md hover:bg-gray-200 transition"
            >
              <span>{selectedRegion || "Region"}</span>
              <FaChevronDown />
            </button>

            {showRegionDropdown && (
              <div className="absolute left-0 right-0 mt-2 bg-white border rounded-md shadow-lg z-50 max-h-60 overflow-y-auto">
                <div
                  onClick={() => handleRegionSelect(null)}
                  className="px-4 py-2 hover:bg-blue-100 cursor-pointer"
                >
                  None
                </div>

                {[
                  "North India",
                  "South India",
                  "Central India",
                  "Northeast",
                  "West India",
                ].map((region) => (
                  <div
                    key={region}
                    className="px-4 py-2 hover:bg-blue-100 cursor-pointer"
                    onClick={() => handleRegionSelect(region)}
                  >
                    {region}
                  </div>
                ))}
              </div>
            )}
          </div> */}

          <div className="relative">
            <button
              onClick={() => setShowRegionDropdown(!showRegionDropdown)}
              className="w-full flex justify-between items-center bg-gray-100 px-4 py-2 rounded-md hover:bg-gray-200 transition"
            >
              <span>
                {regionList.find((r) => r._id === selectedRegion)?.name ||
                  "Region"}
              </span>
              <FaChevronDown />
            </button>

            {showRegionDropdown && (
              <div className="absolute left-0 right-0 mt-2 bg-white border rounded-md shadow-lg z-50 max-h-60 overflow-y-auto">
                {/* None Option */}
                <div
                  onClick={() => handleRegionSelect(null)}
                  className="px-4 py-2 hover:bg-blue-100 cursor-pointer"
                >
                  None
                </div>

                {regionList.map((region) => (
                  <div
                    key={region._id}
                    className="px-4 py-2 hover:bg-blue-100 cursor-pointer"
                    onClick={() => handleRegionSelect(region._id)}
                  >
                    {region.name}
                  </div>
                ))}
              </div>
            )}
          </div>

          <div>
            <div className="flex items-center justify-between">
              <h4 className="text-lg font-semibold mb-3">Price Range</h4>
              {!(priceRange[0] === 0 && priceRange[1] === 9999999) && (
                <button
                  className="text-blue-600 text-xl hover:text-red-500"
                  onClick={() => setPriceRange([0, 9999999])}
                  title="Clear Price Filter"
                >
                  &times;
                </button>
              )}
            </div>

            {[
              { label: "€ 0 - € 5,000", range: [0, 5000] },
              { label: "€ 5,001 - € 10,000", range: [5001, 10000] },
              { label: "€ 10,001 - € 20,000", range: [10001, 20000] },
              { label: "€ 20,001+", range: [20001, 9999999] },
            ].map(({ label, range }) => (
              <label key={label} className="flex items-center gap-2 mb-2">
                <input
                  type="radio"
                  name="priceRange"
                  className="accent-blue-600"
                  checked={
                    priceRange[0] === range[0] && priceRange[1] === range[1]
                  }
                  onChange={() => setPriceRange(range)}
                />
                {label}
              </label>
            ))}
          </div>

          {/* Duration Filter */}
          <div>
            <div className="flex items-center justify-between mb-3">
              <h4 className="text-lg font-semibold mb-3">Price Range</h4>

              {duration && (
                <button
                  className="text-blue-600 text-xl hover:text-red-500"
                  onClick={() => setDuration(null)}
                  title="Clear Duration Filter"
                >
                  &times;
                </button>
              )}
            </div>
            <div className="flex flex-wrap gap-2">
              {["1 Day", "2-3 Days", "4-6 Days", "7+ Days"].map((label) => {
                const isActive =
                  (label === "1 Day" &&
                    duration?.min === 1 &&
                    duration?.max === 1) ||
                  (label === "2-3 Days" &&
                    duration?.min === 2 &&
                    duration?.max === 3) ||
                  (label === "4-6 Days" &&
                    duration?.min === 4 &&
                    duration?.max === 6) ||
                  (label === "7+ Days" && duration?.min === 7);

                return (
                  <button
                    key={label}
                    className={`px-4 py-1 rounded-full transition ${
                      isActive
                        ? "bg-blue-600 text-white"
                        : "bg-gray-200 text-gray-800 hover:bg-blue-600 hover:text-white"
                    }`}
                    onClick={() => {
                      switch (label) {
                        case "1 Day":
                          setDuration({ min: 1, max: 1 });
                          break;
                        case "2-3 Days":
                          setDuration({ min: 2, max: 3 });
                          break;
                        case "4-6 Days":
                          setDuration({ min: 4, max: 6 });
                          break;
                        case "7+ Days":
                          setDuration({ min: 7, max: 999 });
                          break;
                      }
                    }}
                  >
                    {label}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Sort By */}
          <div>
            {/* <h4 className="text-lg font-semibold mb-3">Sort By</h4> */}
            <div className="flex items-center justify-between mb-3">
              <h4 className="text-lg font-semibold mb-3">Sort By</h4>

              {sortBy && (
                <button
                  className="text-blue-600 text-xl hover:text-red-500"
                  onClick={() => setSortBy(null)}
                  title="Clear Sort Filter"
                >
                  &times;
                </button>
              )}
            </div>
            {[
              { label: "Price Low to High", value: "priceAsc" },
              { label: "Price High to Low", value: "priceDesc" },
              { label: "Duration Short to Long", value: "durationAsc" },
              { label: "Duration Long to Short", value: "durationDesc" },
            ].map(({ label, value }) => (
              <label
                key={label}
                className={`flex items-center gap-2 mb-2 p-2 rounded cursor-pointer ${
                  sortBy === value ? "bg-blue-100 font-semibold" : ""
                }`}
              >
                <input
                  type="radio"
                  name="sort"
                  className="accent-blue-600"
                  checked={sortBy === value}
                  onChange={() => setSortBy(value)}
                />
                {label}
              </label>
            ))}
          </div>
        </div>
      </aside>

      <main className="md:w-[75vw] w-full p-6 space-y-6">
        <div className="flex items-center mb-8 w-full max-w-2xl">
          <div className="relative flex-grow">
            <svg
              className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 21l-4.35-4.35M11 19a8 8 0 100-16 8 8 0 000 16z"
              />
            </svg>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                const value = e.target.value;
                setSearchQuery(value);

                // Update URL param on input change
                const newUrl = new URL(window.location.href);
                if (value) {
                  newUrl.searchParams.set("search", value);
                } else {
                  newUrl.searchParams.delete("search");
                }
                window.history.replaceState(null, "", newUrl.toString());
              }}
              placeholder="Search packages..."
              className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
            />
          </div>
          <button
            className="ml-4 px-5 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition font-semibold shadow-md flex items-center"
            onClick={() => {
              setSelectedCategory(null);
              setSelectedRegion(null);
              setPriceRange([0, 9999999]);
              setDuration(null);
              setSortBy(null);
              setSearchQuery("");

              const cleanUrl = `${window.location.origin}${location.pathname}`;
              window.history.replaceState(null, "", cleanUrl);
            }}
          >
            Clear All Filters
          </button>
        </div>

        {loading ? (
          <div className="h-screen flex items-center justify-center">
            <div className="w-16 h-16 border-4 border-blue-500 border-dashed rounded-full animate-spin"></div>
          </div>
        ) : // ) : tours.length === 0 ? (
        !Array.isArray(tours) || tours.length === 0 ? (
          <div className="h-[70vh] flex flex-col items-center justify-center text-center px-4 bg-white rounded-xl">
            <img
              src="https://cdn-icons-png.flaticon.com/512/4076/4076549.png"
              alt="No data"
              className="w-24 h-24 mb-4 opacity-70"
            />
            <h2 className="text-2xl font-semibold text-gray-700">
              No Tours Found
            </h2>
            <p className="text-gray-500 mt-2 max-w-md">
              We couldn't find any tours that match your current filters. Try
              adjusting your filters or search keywords.
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {Array.isArray(tours) &&
              tours.map((tour) => (
                // <Link key={tour._id} to={`/tours/${tour._id}`}>
                //   <div
                //     key={tour._id}
                //     className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-blue-100 group"
                //   >
                <Link
                  key={tour._id}
                  to={`/tours/${tour._id}`}
                  onClick={(e) => {
                    if (e.target.closest("button.wishlist-button")) {
                      e.preventDefault(); // prevent navigation when clicking wishlist
                    }
                    handlePackageClick(tour._id);
                  }}
                >
                  <div
                    key={tour._id}
                    className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-blue-100 group"
                  >
                    <div className="relative">
                      <img
                        src={tour.img}
                        alt={tour.title}
                        className="w-full h-56 object-cover group-hover:scale-105 transition-transform duration-300"
                      />
                      <div
                        className={`absolute top-3 left-3 text-xs font-bold text-white px-2 py-1 rounded ${
                          tour.dealType === "LIMITED DEAL"
                            ? "bg-red-500"
                            : tour.dealType === "POPULAR"
                            ? "bg-purple-500"
                            : tour.dealType === "BEST SELLER"
                            ? "bg-green-500"
                            : "bg-orange-500"
                        }`}
                      >
                        {tour.subCategory && (
                          <span className="block text-xs font-normal mt-1">
                            {tour.subCategory}
                          </span>
                        )}
                      </div>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation(); 
                          handleWishlistToggle(tour._id); // call your toggle
                        }}
                        className="wishlist-button absolute top-3 right-3 bg-white/90 hover:bg-white p-2 rounded-full shadow-md transition-colors"
                      >
                        {wishlist.includes(tour._id) ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5 text-red-500"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 
        7.5 3c1.74 0 3.41 0.81 4.5 2.09C13.09 3.81 14.76 3 
        16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 
        11.54L12 21.35z"
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-5 w-5 text-gray-700 hover:text-red-500"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 
          4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 
          4.5 0 00-6.364 0z"
                            />
                          </svg>
                        )}
                      </button>
                    </div>

                    <div className="p-5">
                      <div className="flex justify-between items-start mb-2">
                        <h3 className="text-lg font-bold text-gray-900">
                          {tour.title}
                        </h3>

                        {tour.originalPrice &&
                          tour.price &&
                          tour.originalPrice > tour.price && (
                            <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2 py-0.5 rounded">
                              {Math.round(
                                ((tour.originalPrice - tour.price) /
                                  tour.originalPrice) *
                                  100
                              )}
                              % OFF
                            </span>
                          )}
                      </div>

                      <div className="flex items-center mr-2">
                        {[...Array(5)].map((_, i) => {
                          const starNumber = i + 1;
                          if (tour.averageRating >= starNumber) {
                            // Full star
                            return (
                              <FaStar
                                key={i}
                                className="text-yellow-400 h-4 w-4"
                              />
                            );
                          } else if (tour.rating >= starNumber - 0.5) {
                            // Half star
                            return (
                              <FaStarHalfAlt
                                key={i}
                                className="text-yellow-400 h-4 w-4"
                              />
                            );
                          } else {
                            // Empty star
                            return (
                              <FaRegStar
                                key={i}
                                className="text-gray-300 h-4 w-4"
                              />
                            );
                          }
                        })}
                      </div>

                      <p className="text-gray-600 text-sm mb-4 line-clamp-2">
                        {tour.description}
                      </p>

                      <div className="flex flex-wrap gap-2 mb-4">
                        {(Array.isArray(tour.providedServices) &&
                        typeof tour.providedServices[0] === "string" &&
                        tour.providedServices[0].startsWith("[")
                          ? JSON.parse(tour.providedServices[0])
                          : tour.providedServices
                        )
                          .slice(0, 3)
                          .map((service, index) => (
                            <span
                              key={index}
                              className="bg-gray-100 text-gray-800 text-xs px-2 py-1 rounded flex items-center"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-3 w-3 mr-1 text-green-500"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                  clipRule="evenodd"
                                />
                              </svg>
                              {service}
                            </span>
                          ))}
                      </div>

                      <div className="border-t border-gray-200 pt-4">
                        <div className="flex justify-between items-center">
                          <div>
                            <div className="text-xs text-gray-500 line-through">
                              € 
                              {tour.originalPrice
                                ? tour.originalPrice.toLocaleString()
                                : "N/A"}
                            </div>
                            <div className="text-xl font-bold text-gray-900">
                              € 
                              {tour.price ? tour.price.toLocaleString() : "N/A"}
                            </div>
                            <div className="text-xs text-gray-500">
                              per person
                            </div>
                          </div>
                          <button className="bg-gradient-to-r from-blue-600 to-blue-800 hover:from-blue-700 hover:to-blue-900 text-white px-4 py-2 rounded-lg font-medium transition-all hover:shadow-md">
                            Book Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
          </div>
        )}
        {/* {tours.length > 0 && ( */}
        {Array.isArray(tours) && tours.length > 0 && (
          <div className="flex justify-center mt-8 space-x-2 items-center">
  <button
    onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
    disabled={currentPage === 1}
    className={`px-4 py-2 rounded ${
      currentPage === 1
        ? "bg-gray-300 cursor-not-allowed"
        : "bg-blue-600 text-white hover:bg-blue-700"
    }`}
  >
    Previous
  </button>

  {renderPagination()}

  <button
    onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
    disabled={currentPage === totalPages}
    className={`px-4 py-2 rounded ${
      currentPage === totalPages
        ? "bg-gray-300 cursor-not-allowed"
        : "bg-blue-600 text-white hover:bg-blue-700"
    }`}
  >
    Next
  </button>
</div>
        )}
      </main>
    </div>
  );
};

export default Beach;

